import React from "react";

const MyButton = ({ children }) => {
  return <div className="mybutton">{children}</div>;
};

export default MyButton;
